import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MY_TASKS_KEY } from '@witty-board/shared'
import { useMeQuery } from '../api/auth.js'
import { useProjectsQuery } from '../api/projects.js'
import { TaskBoard } from '../features/board/TaskBoard.js'
import { BoardSkeleton } from '../features/board/BoardSkeleton.js'
import { RecentActivity } from '../features/home/RecentActivity.js'
import { useDoneWindow } from '../lib/done-window.js'

/**
 * Inicio (CLAUDE.md §6, fase 7; antes "Mis tareas"): la actividad reciente de
 * todos los proyectos arriba y, debajo, las tareas de todos los proyectos
 * asignadas al usuario actual, con el color y la clave del proyecto
 * prominentes porque ahí la procedencia es la información crítica. Sin alta
 * rápida: no hay un único proyecto al que asignar una tarea nueva.
 */
export function HomePage() {
  const { t } = useTranslation()
  const me = useMeQuery()
  const projects = useProjectsQuery()
  const { doneSince } = useDoneWindow()
  const projectsById = useMemo(
    () => new Map((projects.data ?? []).map((project) => [project.id, project] as const)),
    [projects.data],
  )

  if (me.isPending || projects.isPending) return <BoardSkeleton />
  if (!me.data) return null

  return (
    <div className="flex flex-col">
      <header className="flex shrink-0 items-center gap-2 px-6 pt-6">
        <h1 className="text-title font-semibold text-text">{t('home.title')}</h1>
      </header>

      <div className="shrink-0 px-6 pt-4">
        <RecentActivity />
      </div>

      <h2 className="shrink-0 px-6 pt-6 text-body font-medium text-text">{t('home.myTasks')}</h2>
      <TaskBoard
        filters={{ assigneeId: me.data.id, doneSince }}
        projectsById={projectsById}
        boardKey={MY_TASKS_KEY}
        showProjectKey
      />
    </div>
  )
}
